"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SuccessActions = exports.SuccessDescription = exports.SuccessSubTitle = exports.SuccessTitle = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Link = require("../Button/Link");

var _Button = _interopRequireDefault(require("../Ui/Button"));

var _content = require("../../style/content");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var SuccessTitle = _styledComponents["default"].h1.withConfig({
  displayName: "Success__SuccessTitle",
  componentId: "rmi8u-0"
})(["", ";text-align:center;margin-top:32px;margin-bottom:48px;"], function (_ref) {
  var theme = _ref.theme;
  return theme.typography.titleXXL;
});

exports.SuccessTitle = SuccessTitle;
var SuccessContentText = (0, _styledComponents.css)(["", " ", ";text-align:center;", " mark{background-color:transparent;}"], _content.DescriptionResetStyle, function (_ref2) {
  var theme = _ref2.theme;
  return theme.typography.body;
}, function (_ref3) {
  var theme = _ref3.theme;

  switch (theme.mode) {
    case 'dark':
      return (0, _styledComponents.css)(["&,mark{color:var(--colors-blank);}"]);

    case 'light':
    default:
      return (0, _styledComponents.css)(["&,mark{color:var(--colors-bayoux);}"]);
  }
});

var SuccessSubTitle = _styledComponents["default"].div.withConfig({
  displayName: "Success__SuccessSubTitle",
  componentId: "rmi8u-1"
})(["", " line-height:1.625em;max-width:385px;margin:0 auto;margin-bottom:50px;"], SuccessContentText);

exports.SuccessSubTitle = SuccessSubTitle;

var SuccessDescription = _styledComponents["default"].div.withConfig({
  displayName: "Success__SuccessDescription",
  componentId: "rmi8u-2"
})(["", " line-height:1.5em;max-width:510px;margin:0 auto;"], SuccessContentText);

exports.SuccessDescription = SuccessDescription;

var SuccessActions = _styledComponents["default"].div.withConfig({
  displayName: "Success__SuccessActions",
  componentId: "rmi8u-3"
})(["display:flex;align-items:center;justify-content:center;padding-top:60px;margin-bottom:40px;", ",", ",a,button{--spacing:36px;margin-left:var(--spacing);&:first-child{margin-left:0;}@media screen and (min-width:", "){--spacing:56px;}}"], _Link.StyledLink, _Button["default"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.screenMedium;
});

exports.SuccessActions = SuccessActions;